import React, { Suspense, useEffect } from "react";
import { Route, Routes } from "react-router";
import { Layout } from "./components/Layout";
import { Login } from "./pages/Login";
import { Cuestion } from "./pages/Cuestion";
import { Home } from "./pages/Home";
import { Resultado } from "./pages/Resultado";
import { Noticia } from "./pages/Noticia";
import { Noticias } from "./pages/Noticias";
import { MisCuestionarios } from "./pages/MisCuestionarios";
import "./styles/Autodiagnostico.css";
import { ThemeProvider } from "@mui/material/styles";
import "./App.css";
import { PaginaNoExiste } from "./pages/PaginaNoExiste";
import { appTheme } from "./components/commons/Theme";
import { MisCuestionariosContextProvider } from "./context/MisCuestionariosContext";
import { CuestionContextProvider } from "./context/CuestionContext";
import { ResultadoContextProvider } from "./context/ResultadoContext";
import { GeneralContextProvider } from "./context/GeneralContext";
import { EjesContextProvider } from "./context/EjesContext";
import { Faqs } from "./pages/Faqs";
import { Ejes } from "./pages/Ejes";
import { CrearPerfilEmpresarial } from "./pages/CrearPerfilEmpresarial";
import { Glosario } from "./pages/Glosario";
import {PreguntasTemas}from "./pages/PreguntasTemas"
import { useTranslation } from 'react-i18next';
import Parser from 'html-react-parser';

export default function App() {
    
    return (
        <Suspense fallback="loading">
            <GeneralContextProvider>
                <ThemeProvider theme={appTheme}>
                    <Layout>
                        <Routes>
                            <Route exact path="/" element={<Home />} />
                            <Route
                                path="/Cuestion"
                                element={
                                    <CuestionContextProvider>
                                        <Cuestion />
                                    </CuestionContextProvider>
                                }
                            />
                            <Route path="/Identificarse" element={<Login />} />
                            <Route
                                path="/Resultado"
                                element={
                                    <ResultadoContextProvider>
                                        <Resultado />
                                    </ResultadoContextProvider>
                                }
                            />
                            <Route
                                path="/MisCuestionarios"
                                element={
                                    <MisCuestionariosContextProvider>
                                        <MisCuestionarios />
                                    </MisCuestionariosContextProvider>
                                }
                            />
                            <Route
                                path="/Noticia/:key"
                                element={
                                    <Noticia />
                                }
                            />
                            <Route
                                path="/Noticias"
                                element={
                                    <Noticias />
                                }
                            />
                            <Route
                                path="/Faqs"
                                element={
                                    <Faqs />
                                }
                            />
                            <Route
                                path="/Ejes"
                                element={
                                    <EjesContextProvider>
                                        <Ejes />
                                    </EjesContextProvider>

                                }
                            />
                            <Route
                                path="/Crear-perfil-empresarial"
                                element={
                                    <CrearPerfilEmpresarial />
                                }
                            />
                            <Route
                                path="/Glosario-de-terminos"
                                element={
                                    <Glosario />
                                }
                            />
                            {/*Esto es para poder obtener todas las preguntas formateadas para pegarlas en un word. Solo se descomenta cuando haga falta sacar el word. As� no es accesible al mundo.*/}
                            {/*<Route*/}
                            {/*    path="/PreguntasTemas"*/}
                            {/*    element={*/}
                            {/*        <PreguntasTemas/>*/}
                            {/*    }*/}
                            {/*/>*/}
                            <Route path="*" element={<PaginaNoExiste />} />
                        </Routes>
                    </Layout>
                </ThemeProvider>
            </GeneralContextProvider>
        </Suspense>
    );
}
